import _extends from '@babel/runtime/helpers/extends';
import { Chip } from '@archer-technologies/ui-components';
import { GroupingPanel } from '@devexpress/dx-react-grid-material-ui';
import { createElement } from 'react';

var GroupingPanelEmptyMessageComponent = function GroupingPanelEmptyMessageComponent(props) {
  return /*#__PURE__*/createElement(GroupingPanel.EmptyMessage, _extends({}, props, {
    className: "grouping-panel-empty-message"
  }));
};

var GroupingPanelItemComponent = function GroupingPanelItemComponent(_ref) {
  var title = _ref.item.column.title,
      onGroup = _ref.onGroup;
  return /*#__PURE__*/createElement(Chip, {
    label: title,
    onDelete: onGroup,
    onClick: onGroup,
    clickable: true,
    id: "grouped-item-chip-id-".concat(title)
  });
};

export { GroupingPanelEmptyMessageComponent, GroupingPanelItemComponent };